import React from 'react';

type HamburgerIconProps = {
    className?: string;
};

export function HamburgerIcon({ className }: HamburgerIconProps) {
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 16 16"
            fill="none"
            aria-hidden="true"
        >
            <path
                transform="translate(0 3)"
                d="M15.3496 9.21777C14.8452 9.72068 14.16 10.0039 13.4463 10.0039C8.99992 10.0039 4.49996 10.0039 0 10.0039L0.649414 9.35645C1.15396 8.85337 1.84078 8.57022 2.55469 8.57031C7.03701 8.59459 11.5 8.57031 16 8.57031L15.3496 9.21777ZM15.3496 4.9375C14.8452 5.44041 14.16 5.72363 13.4463 5.72363C8.99992 5.72363 4.49996 5.72363 0 5.72363L0.649414 5.07617C1.15396 4.57309 1.84078 4.28994 2.55469 4.29004C7.03701 4.31431 11.5 4.29004 16 4.29004L15.3496 4.9375ZM15.3496 0.647461C14.8452 1.15037 14.16 1.43359 13.4463 1.43359C8.99992 1.43359 4.49996 1.43359 0 1.43359L0.649414 0.786133C1.15396 0.283056 1.84078 -9.55441e-05 2.55469 2.4184e-08C7.03701 0.0242725 11.5 2.4184e-08 16 2.4184e-08L15.3496 0.647461Z"
                fill="currentColor"
            />
        </svg>
    );
}
